import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {completePasswordReset} from "../../requests/UserRequests";
import ResetPasswordFinishForm from "./ResetPasswordFinishForm";
import SimpleHeader from "../header/SimpleHeader";
import Footer from "../footer/Footer";

class ResetPasswordFinishPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userNotFound: false,
      user: null
    }
  }


  componentDidMount() {
    this.props.getUserByPasswordReset(this.props.passwordReset).then((user) => {
      this.setState({user: user});
    }).catch(() => {
      this.setState({userNotFound: true});
    });
  }

  render() {
    return (
      <React.Fragment>
        <SimpleHeader/>
        <div className={"container mt-5"}>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mx-auto">
              <div className="card">
                {this.state.user &&
                <ResetPasswordFinishForm onSubmit={completePasswordReset} id={this.state.user.PasswordReset}/>}
                {this.state.userNotFound && <div>
                  <h1>Invalid reset url.</h1>
                </div>}
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </React.Fragment>
    );
  }
}

ResetPasswordFinishPage.propTypes = {
  getUserByPasswordReset: PropTypes.func.isRequired,
  passwordReset: PropTypes.string.isRequired,
};

export default ResetPasswordFinishPage;
